import { Alert, Button, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import { useState } from "react";
import { useCustomTheme } from "services/hooks";
import { useAppDispatch, useAppSelector } from "store/hooks";
import styles from "./buy.module.scss";
import { setActiveDialog } from "store/app";
import { DialogType } from "store/app/types";
import Form from "features/checkout/components/Form";

const Buy = () => {
  const customTheme = useCustomTheme();
  const [ customAmount, setCustomAmount ] = useState(0);
  const { user } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();

  const handleChange = (event) => {
    const input = event.target.value;
    const regex = /^\d*$/; // Regex to allow only digits
    if(!regex.test(input)) return;
    setCustomAmount(input);
  };

  return (
    <>
      <div className="container h-100">
        <div className={`${styles.buy} row justify-content-center h-100 align-items-center`}>
          <div className="col-lg-8 col-xl-6 col-12">
            <ThemeProvider theme={customTheme}>
              <Paper elevation={3} className={`${styles.paper}`}>
                <Typography align="center" fontWeight={700} className="mb-5">Buy & Plant Trees Now!</Typography>
                <div className="d-flex justify-content-center mb-5">
                  <TextField 
                    label="Amount" 
                    variant="outlined" 
                    helperText="How many trees do you want to purchase & plant?"
                    onChange={handleChange}
                  />
                </div>
                {
                  !user ? (
                    <>
                      <Alert severity="error" className="mb-3">Please login or create an account to continue</Alert>
                      <div className="d-flex">
                        <Button 
                          onClick={() => dispatch( setActiveDialog(DialogType.Signup) )}
                          fullWidth className="me-2" variant="contained" color="primary" disableElevation
                          >
                            Create New Account
                        </Button>
                        <Button 
                          onClick={() => dispatch( setActiveDialog(DialogType.Login) )}
                          fullWidth className="ms-2" variant="contained" color="primary" disableElevation
                          >
                            Login
                        </Button>
                      </div>
                    </>
                  ) : <Form customTreesAmount={customAmount}/>
                }
              </Paper>
            </ThemeProvider>
          </div>
        </div>
      </div>
    </>
  )
};

export default Buy;
